export enum LocalStorageKeys {
  CLOSE = 'close',
  TRADING_VIEW_CHART_PROPERTIES = 'tradingview.chartproperties',
  LOCAL_STORAGE_USER_TYPE_KEY = 'userType',
  EXTERNAL_DEPOSIT = 'external-deposit',
  SENTRY_USER = 'sentry_user',
  FIREBASE_TOKEN = 'firebaseToken',
  STUDIES = 'studies_',
  LEVERAGE = 'leverage',
  SELECTED_POOL = 'selectedPool',
  ACTIVE_PAIRS = 'activePairs',
  CHART_DRAWINGS = 'chartDrawings',
  CHART_INDICATORS = 'chartIndicators',
  SOUND_ON = 'soundOn',
  HOTKEYS_ENABLED = 'hotkeysEnabled',
  DEFAULT_TRADING_MODE = 'defaultTradingMode',
  LAST_USED_TRADING_MODE = 'lastUsedTradingMode',
  REMEMBER_SELECTED_LEVERAGE = 'rememberSelectedLeverage',
  SHOW_ORDERS_AND_ENTRIES_ON_CHART = 'showOrdersAndEntriesOnChart',
  HIDE_COLLATERAL_TIP_PROMPT = 'hideCollateralTipPrompt',
  HIDE_TRADE_CONFIRMATION = 'hideTradeConfirmation',
  HIDE_SETTLE_ACCRUED_INTEREST_CONFIRMATION = 'hideSettleAccruedInterestConfirmation',
  HIDE_SINGLE_REALIZED_PNL_SETTLEMENT_CONFIRMATION = 'hideSingleRealizedPnlSettlementConfirmation',
  HIDE_SINGLE_TRANSACTIONS_SETTLEMENT_CONFIRMATION = 'hideSingleTransactionsSettlementConfirmation',
  ENABLE_COPY_TRADING = 'enableCopyTrading',
  API_KEY = 'apiKey',
  BONDTRADER_PROMO_BANNER_DISMISSED = 'bondtrader-promo-banner-dismissed',
}
